import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const CompanyTimeline = () => {
  const [activeYear, setActiveYear] = useState(2025);

  const timelineData = [
    {
      year: 2021,
      title: "Gründung der Cyfire Rechtsanwaltsgesellschaft mbH",
      description: "Gründung der Cyfire Rechtsanwaltsgesellschaft mbH mit Fokus auf innovative Rechtsdienstleistungen und digitale Mandantenbetreuung.",
      icon: "Building",
      color: "bg-primary"
    },
    {
      year: 2022,
      title: "Expansion der Beratungsfelder",
      description: "Erweiterung um Wirtschaftsrecht, Arbeitsrecht, Immobilienrecht sowie Urheber- und Markenrecht. Aufbau eines spezialisierten Anwaltsteams.",
      icon: "TrendingUp",
      color: "bg-accent"
    },
    {
      year: 2023,
      title: "Etablierung digitaler Partnerschaften",
      description: "Unter anderem mit Rechtschutzversicherungen zur Verbesserung der Mandantenerreichbarkeit und Servicequalität.",
      icon: "Smartphone",
      color: "bg-trust-builder"
    },
    {
      year: 2024,
      title: "Wachstum & Plattformentwicklung",
      description: "Strategischer Ausbau der digitalen Rechtsdienstleistungen und Entwicklung der Advocall-Plattform für eine breitere Mandantenreichweite.",
      icon: "Shield",
      color: "bg-secondary"
    },
    {
      year: 2025,
      title: "Gründung der Advocall Rechtsanwaltsgesellschaft mbH",
      description: "Aufgrund des großen Erfolges wurde das Projekt Advocall als eigenständige Advocall Rechtsanwaltsgesellschaft mbH gegründet.",
      icon: "Rocket",
      color: "bg-cta"
    }
  ];

  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Unsere Geschichte
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Von der traditionellen Kanzlei zur innovativen Rechtsberatungsplattform - 
            eine Reise der kontinuierlichen Verbesserung und Mandantenorientierung.
          </p>
        </div>

        <div className="relative">
          {/* Timeline Line */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-border hidden lg:block"></div>

          <div className="space-y-12 lg:space-y-16">
            {timelineData?.map((item, index) => (
              <motion.div
                key={item?.year}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className={`flex flex-col lg:flex-row items-center gap-8 ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                }`}
                onMouseEnter={() => setActiveYear(item?.year)}
              >
                {/* Content */}
                <div className="flex-1 lg:max-w-md">
                  <div className={`bg-white rounded-xl p-6 shadow-professional border-l-4 ${
                    activeYear === item?.year ? 'border-primary shadow-elevated' : 'border-border'
                  } transition-all duration-300 card-hover`}>
                    <div className="flex items-center space-x-3 mb-4">
                      <div className={`flex items-center justify-center w-10 h-10 ${item?.color} rounded-lg`}>
                        <Icon name={item?.icon} size={20} color="white" strokeWidth={2} />
                      </div>
                      <span className="text-2xl font-bold text-primary">{item?.year}</span>
                    </div>
                    <h3 className="text-xl font-semibold text-text-primary mb-3">
                      {item?.title}
                    </h3>
                    <p className="text-text-secondary leading-relaxed">
                      {item?.description}
                    </p>
                  </div>
                </div>

                {/* Timeline Node */}
                <div className="relative hidden lg:block">
                  <div className={`w-6 h-6 rounded-full border-4 border-white ${
                    activeYear === item?.year ? item?.color : 'bg-border'
                  } transition-all duration-300 shadow-sm`}></div>
                </div>

                {/* Spacer for alternating layout */}
                <div className="flex-1 lg:max-w-md hidden lg:block"></div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyTimeline;